var _circle, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhotoBtn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_820_13999)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.333 6.66683H15.2197L13.9997 5.3335H9.99967L8.77967 6.66683H6.66634C5.93301 6.66683 5.33301 7.26683 5.33301 8.00016V16.0002C5.33301 16.7335 5.93301 17.3335 6.66634 17.3335H17.333C18.0663 17.3335 18.6663 16.7335 18.6663 16.0002V8.00016C18.6663 7.26683 18.0663 6.66683 17.333 6.66683ZM17.333 16.0002H6.66634V8.00016H9.36634L10.5863 6.66683H13.413L14.633 8.00016H17.333V16.0002ZM11.9997 8.66683C10.1597 8.66683 8.66634 10.1602 8.66634 12.0002C8.66634 13.8402 10.1597 15.3335 11.9997 15.3335C13.8397 15.3335 15.333 13.8402 15.333 12.0002C15.333 10.1602 13.8397 8.66683 11.9997 8.66683ZM11.9997 14.0002C10.8997 14.0002 9.99967 13.1002 9.99967 12.0002C9.99967 10.9002 10.8997 10.0002 11.9997 10.0002C13.0997 10.0002 13.9997 10.9002 13.9997 12.0002C13.9997 13.1002 13.0997 14.0002 11.9997 14.0002Z",
    fill: "#878E95"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_820_13999"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(4 4)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhotoBtn);
export default __webpack_public_path__ + "static/media/photo-btn.0b07427380f30b0a8b82c78f67f366ef.svg";
export { ForwardRef as ReactComponent };